/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const LineChart = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 80 80'>
			<polyline
				fill='none'
				stroke='#fea58e'
				strokeWidth='6'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeMiterlimit='10'
				points='4,73 52,8 76,45 '
			></polyline>
			<polyline
				fill='none'
				stroke='#51d3d9'
				strokeWidth='6'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeMiterlimit='10'
				points='4,39 26,9 50,41 76,6'
			></polyline>
		</svg>
	);
};

export default LineChart;
